import React, { useContext } from 'react';
import { WardrobesConfigsContext } from '../../contexts/WardrobesConfigsContext';
import { ActiveWardrobeContext } from '../../contexts/ActiveWardrobeContext';
import { PriceContext } from '../../contexts/PriceContext';
import calculatePrice from '../../helpers/calculatePrice';
import { toast } from 'react-toastify';
import Button from 'components/buttons/Button';

const AccessoriesControlBar = ({ item, index, deleteItem, changePosition, checkPossibility }) => {
  const { wardrobesConfigs, setWardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { activeWardrobe } = useContext(ActiveWardrobeContext);
  const { setPrice } = useContext(PriceContext);

  const NotifyDeletedZDMessage = ({ closeToast, actualItem }) => {
    return (
      <div>
        <span>Usunięcie oświetlenia głównego spowoduje usunięcie oświetlenia dodatkowego</span>
        <br />
        <Button
          text="Tak, usuń"
          click={() => {
            const wardrobesConfigsCopy = wardrobesConfigs;
            const ZDToDeleteLeft = wardrobesConfigsCopy[
              activeWardrobe
            ].accessories.left.filter(el => el.safo.toUpperCase().includes('ZD'));
            const ZDToDeleteCenter = wardrobesConfigsCopy[
              activeWardrobe
            ].accessories.center.filter(el => el.safo.toUpperCase().includes('ZD'));
            const ZDToDeleteRight = wardrobesConfigsCopy[
              activeWardrobe
            ].accessories.right.filter(el => el.safo.toUpperCase().includes('ZD'));

            wardrobesConfigsCopy[activeWardrobe].accessories.left = wardrobesConfigsCopy[
              activeWardrobe
            ].accessories.left.filter(el => !ZDToDeleteLeft.find(item => item.id === el.id));

            wardrobesConfigsCopy[activeWardrobe].accessories.center = wardrobesConfigsCopy[
              activeWardrobe
            ].accessories.center.filter(el => !ZDToDeleteCenter.find(item => item.id === el.id));

            wardrobesConfigsCopy[activeWardrobe].accessories.right = wardrobesConfigsCopy[
              activeWardrobe
            ].accessories.right.filter(el => !ZDToDeleteRight.find(item => item.id === el.id));

            setWardrobesConfigs(wardrobesConfigsCopy);
            deleteItem(actualItem.id);
            setPrice(calculatePrice(wardrobesConfigsCopy[activeWardrobe]));
            closeToast();
          }}
        />
        <Button text="Anuluj" click={closeToast} />
      </div>
    );
  };

  function NotifyDeletedZD(actualItem) {
    toast(<NotifyDeletedZDMessage actualItem={actualItem} />, {
      closeOnClick: false,
      position: 'top-right',
      autoClose: 15000,
      hideProgressBar: true,
      toastId: 1, // show only one
      progress: undefined,
    });
  }

  const deleteElem = item => {
    const wardrobesConfigsCopy = wardrobesConfigs;
    const ZDToDeleteLeft = wardrobesConfigsCopy[activeWardrobe].accessories.left.filter(el =>
      el.safo.toUpperCase().includes('ZD'),
    );
    const ZDToDeleteCenter = wardrobesConfigsCopy[activeWardrobe].accessories.center.filter(el =>
      el.safo.toUpperCase().includes('ZD'),
    );
    const ZDToDeleteRight = wardrobesConfigsCopy[activeWardrobe].accessories.right.filter(el =>
      el.safo.toUpperCase().includes('ZD'),
    );

    if (
      item.safo.toUpperCase().includes('ZG') &&
      (ZDToDeleteCenter.length || ZDToDeleteLeft.length || ZDToDeleteRight.length)
    ) {
      NotifyDeletedZD(item);
    } else {
      deleteItem(item.id);
      setPrice(calculatePrice(wardrobesConfigs[activeWardrobe]));
    }
  };

  return (
    <div className="accessories__control-bar">
      <button
        className={`control-bar__button control-bar__button--font-size control-bar__button--display-flex control-bar__button--rotate ${
          checkPossibility(item, index, 'up') ? '' : 'disabled'
        }`}
        onClick={() => changePosition(item, index, 'up')}>
        <span className="icon-left-arrow" />
      </button>
      <button
        className={`control-bar__button control-bar__button--font-size control-bar__button--display-flex control-bar__button--rotate ${
          checkPossibility(item, index, 'down') ? '' : 'disabled'
        }`}
        onClick={() => changePosition(item, index, 'down')}>
        <span className="icon-right-arrow" />
      </button>
      <button className="control-bar__button" onClick={() => deleteElem(item)}>
        <span className="icon__remove" />
      </button>
    </div>
  );
};

export default AccessoriesControlBar;
